var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-support",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "headset",
    d: "M12,3.374l-0,0.001c3.583,-0 6.53,2.728 6.875,6.221l-1.812,-0c-1.078,0.001 -1.951,0.875 -1.952,1.953l-0,3.165c0.001,1.078 0.874,1.952 1.952,1.953l1.268,-0c0.201,-0 0.395,-0.031 0.577,-0.088c0,0 0,0.753 0,0.753c-0.002,1.017 -0.827,1.841 -1.844,1.843l-1.249,-0c-0.207,-0.274 -0.537,-0.452 -0.907,-0.452c-0,0 -1.991,0 -1.991,0c-0.628,0 -1.138,0.51 -1.138,1.139c-0,0.628 0.51,1.138 1.138,1.138c0,-0 1.991,-0 1.991,-0c0.37,-0 0.7,-0.177 0.908,-0.451l1.248,-0c1.777,-0.002 3.217,-1.442 3.219,-3.219l-0,-7.07c-0,-2.291 -0.937,-4.364 -2.448,-5.855l-0,0.001l-0,-0.001l-0.001,-0.001c-1.488,-1.486 -3.541,-2.404 -5.809,-2.404l-0,0c-0,0 -0.118,0 -0.025,0c-4.575,0 -8.283,3.709 -8.283,8.283l0,4.431c0.002,1.078 0.875,1.951 1.953,1.953l1.267,-0c1.078,-0.002 1.951,-0.875 1.952,-1.953l0,-3.166c-0.001,-1.078 -0.874,-1.951 -1.952,-1.952l-1.811,-0c0.356,-3.503 3.297,-6.221 6.874,-6.222Zm6.908,7.596l0,3.743c-0,0.32 -0.259,0.579 -0.579,0.579l-1.265,0c-0.32,0 -0.579,-0.259 -0.579,-0.578c-0,-0 -0,-3.165 -0,-3.165c0,-0.319 0.259,-0.578 0.579,-0.579l1.844,0Zm-11.972,0c0.32,0 0.579,0.259 0.579,0.579c0,-0 0,3.164 0,3.164c-0,0.32 -0.259,0.579 -0.579,0.579c0,0 -1.265,0 -1.265,0c-0.32,-0 -0.579,-0.259 -0.579,-0.579c-0,0 -0,-3.743 -0,-3.743l1.844,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph-megaphone-light"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRSupport);
export default __webpack_public_path__ + "static/media/iconR-support.ecd330e69a96c16a4985b29640b8ac39.svg";
export { ForwardRef as ReactComponent };